import dayjs, { formatDateString } from '~libs/dayjs';

import { Column } from '~components/table-view-v3';

const columnsFactory = (start_date?: string, end_date?: string) => {
  const dayCount = start_date && end_date ? dayjs(end_date).diff(dayjs(start_date), 'day') + 1 : 0;

  const columns: Column[] = [
    {
      id: 'sah_level',
      header: 'SAH Level',
      type: 'text',
      classNames: {
        header: 'cell-align-left',
        column: 'cell-align-left',
      },
    },
    {
      id: 'annual_amount',
      header: 'Year Funds',
      type: 'currency',
      classNames: {
        header: 'cell-align-center',
        column: 'cell-align-center',
      },
      deriveValue: (row) => row.daily_amount * 365,
    },
    {
      id: 'amount_for_duration',
      header: `${formatDateString(start_date)} - ${formatDateString(end_date)}`,
      type: 'currency',
      classNames: {
        header: 'cell-align-center',
        column: 'cell-align-center',
      },
      deriveValue: (row) => row.daily_amount * dayCount,
    },
  ];

  return columns;
};

export default columnsFactory;
